import state from './moduleQuestionManagementState.js'
import mutations from './moduleQuestionManagementMutations.js'
import actions from './moduleQuestionManagementActions.js'
import getters from './moduleQuestionManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

